import dayjs from "dayjs";
import CONSTNAME from "@/ConstName.js";
import * as utils from "@/utils/ganttUnit.js";

const getter = {
  // 视图模式
  noWBS(state) {
    switch (state.showMode) {
        case "right":
          return true;
        default:
          return false;
    }
  },
  noGantt(state) {
    switch (state.showMode) {
        case "left":
          return true;
        default:
          return false;
    }
  },
  // 原始起止
  sourceStartAndEnd(state) {
    const _type = state.cellUnitType;
    const _start = state.viewSchem.start;
    const _end = state.viewSchem.end;
    const _fillType = state.viewSchem.timelineFillType;
    const result = {
      start: undefined,
      end: undefined,
      fillType: _fillType,
    };
    let _startTimeStamp = 0;
    let startDay = "";
      if (_start != null && _start >= 0 && _start != "") {
        startDay = dayjs(_start).startOf(_type).subtract(2, _type);
      } else {
        startDay = dayjs(Date.now()).startOf(_type).subtract(2, _type);
      }
    _startTimeStamp = startDay.valueOf();
    // 止
    let _endTimeStamp = 0;
    const _toltalNums = 6; // 最终单元格数量·放大模式需要计算最新比例·异常终止时间默认7个单元格
    if (
      _end != null &&
      _end > _start
    ) {
      _endTimeStamp = dayjs(_end).endOf(_type).valueOf();
    } else {
      _endTimeStamp = dayjs(_startTimeStamp).endOf(_type).add(_toltalNums, _type).valueOf();
    }
    result.start = _startTimeStamp;
    result.end = _endTimeStamp;
    return result;
  },
  // WBS表格内容总宽 ===依赖 noWBS ===
  wbsContentWidth(state, getters) {
    let result = 0;
    if (!getters.noWBS) {
      // wbs内容宽度
      const _treeWidth = state.noTree ? 0 : state.treeWidth; // 树宽
      for (const item of state.wbsHeaderArr) {
        if (item.visible === true && typeof item.colWidth == "number") {
          result += item.colWidth;
        }
      }
      const rest = state.viewSchem.tableLineAdjustable ? 200 : 50;
      result = result + _treeWidth + rest; // 选中栏内置树宽20 + 多出的200给拉伸预留空间

    }
    return result;
  },
  /* 打印模式 */
  // 时间轴展示层数
  timelineShowRows(state) {
    /* if (state.viewSchem.isIndexMode) {
      return state.viewSchem.timelineShowRows;
    } else {
      return state.viewSchem.timelineShowRows;
    } */
    return state.viewSchem.timelineShowRows;
  },
  // 打印拼凑内容总高 ===依赖 timelineShowRows ===
  printTotalHeight(state, getters) {
    const _todosNum = state.todoShow ? state[CONSTNAME.TODOS + "_rowsNum"] : 0;
    const _summarysHeight = state.summaryShow ? state[CONSTNAME.SUMMARY + "_rowsNum"] * state.summaryCellHeight : 0;
    const _timesLinesHeight = state.viewSchem.ganttHeadShow ? state.timesLineHeight * getters.timelineShowRows : 0;
    const _mainHeight = (state[CONSTNAME.PLANS + "_map"].totalRow + _todosNum) * state.cellHeight + _summarysHeight + _timesLinesHeight;
    return (_mainHeight + 8 + 1);
  },
  /* // 自适应打印整图内容铺开总宽度 ===依赖 printTotalHeight ===
  autoPrintGanttWidth(state, getters) {
    const sourceW = state.viewSchem.printModeWidth;
    const sourceH = state.viewSchem.printModeHeight;
    const printW = (getters.printTotalHeight * sourceW / sourceH);
    return printW;
  }, */
  // 控件总宽 ===依赖 autoPrintGanttWidth ===
  ganttWidth(state, getters) {
    /* if (
      state.viewSchem.timelineFillType == 4
    ) {
      return getters.autoPrintGanttWidth;
    } */
    return state.ganttWidth;
  },
  // 控件总宽 ===依赖 printTotalHeight ===
  ganttHeight(state, getters) {
    if (state.viewSchem.isPrintModeShow || state.printStatus) {
      return getters.printTotalHeight;
    } else {
      return state.ganttHeight;
    }
  },
  /*
    WBS视口宽  ===依赖 wbsContentWidth ===
  */
  WBSLeft(state, getters) {
    const _ganttWidth = getters.ganttWidth;
    if (getters.noWBS) {
      return 1;
    } else if (getters.noGantt) {
      const width = _ganttWidth;
      return width;
    } else {
      let sourceLeft = 50;
      if (state.viewSchem.initTableWidthFlag == "auto") {
        sourceLeft = state.noTree ? 50 : state.treeWidth; // 取树宽
      } else {
        sourceLeft = state.initTableWidth; // 取配置宽
      }
      let result = sourceLeft;
      if (sourceLeft > _ganttWidth) {
        const min = (_ganttWidth / 2);
        result = getters.wbsContentWidth <= min ? getters.wbsContentWidth : min;
      }
      return result;

    }
  },
  /* // 自适应打印图区内容宽度  ===依赖 autoPrintGanttWidth WBSLeft ===
  autoPrintContentWidth(state, getters) {
    const _wbsWidth = getters.WBSLeft;
    const contentW = getters.autoPrintGanttWidth - _wbsWidth;
    return contentW;
  }, */

  /* 构建合适的时间轴起止节点时间  ===依赖 sourceStartAndEnd WBSLeft ===
    起点取项目起始时间根据视图方案设定时间单位类型置为整点数然后前推2个设定时间类型单位;
    终点(优先)取项目设定终点时间大于最小屏幕宽度所需的条数对应时间值,否则取所需的条数对应时间值。
    return {
      start: 时间戳,
      end: 时间戳,
      fillType: "1", // 1:数量填充 2: 放大填充 3:无填充模式 4:打印比例
    }
  */
  totalStartAndEnd(state, getters) {
    const _type = state.cellUnitType;
    const _startTimeStamp = getters.sourceStartAndEnd.start;
    let _endTimeStamp = getters.sourceStartAndEnd.end;
    const _fillType = getters.sourceStartAndEnd.fillType;
    const _end = _endTimeStamp;
    const result = {
      start: _startTimeStamp,
      end: _end,
      fillType: _fillType,
    };
    // console.group("时间轴"); // Clg
    const _baseWidth = state.cellWidth * state.cellScale;
    const _sourceFilltype = state.viewSchem.timelineFillType;
    // 止
    if (_sourceFilltype === 1) {
      const _ganttWidth = state.ganttWidth;
      // 兼容最小视口列数·会导致时间轴变化·任务位置变化·连线变化
      const _wbsWidth = getters.WBSLeft;
      const _ganttBoxWidth = _ganttWidth - _wbsWidth;
      let minCount = parseInt(_ganttBoxWidth / _baseWidth);
      if (_ganttBoxWidth % _baseWidth == 0) {
        minCount = parseInt(_ganttBoxWidth / _baseWidth) - 1;
      }

      // console.log("时间轴下限数量[宽]:", minCount, _ganttWidth); // Clg
      const flag = dayjs(_end).diff(dayjs(_startTimeStamp), _type);
      if (flag < minCount) {
        _endTimeStamp = dayjs(_startTimeStamp).add(minCount, _type).valueOf();
        console.log("数量填充", minCount);

        result.end = _endTimeStamp;
      }
    }
    // console.groupEnd("时间轴"); // Clg
    return result;

  },
  /* 构建时间轴每一个单元  ===依赖 totalStartAndEnd ===
    return {
      show: "展示内容",
      date: dayjs(date),
      holidayType: 0/1/2,
      holidayColor: "red",
      title, "hover展示"
    }
  */
  durationTimeArr(state, getters) {
    const _type = state.cellUnitType;
    const _config = state.viewSchem.holiday;
    const _viewSchem = state.viewSchem;
    const _start = dayjs(getters.totalStartAndEnd.start);
    const _end = dayjs(getters.totalStartAndEnd.end);
    const result = utils.handleTimesLineSet({
      start: _start,
      end: _end,
    }, _type, _config, _viewSchem, dayjs);
    // console.log("计划时间跨度", result);
    return result;
  },
  // 放大显示比例模式·右侧图区填充满最小比例  ===依赖 WBSLeft durationTimeArr ===
  minFillCellScale: (state, getters) => {
    if (state.viewSchem.timelineFillType === 2) {
      const _ganttWidth = state.ganttWidth;
      const _wbsWidth = getters.WBSLeft;
      const _ganttBoxWidth = _ganttWidth - _wbsWidth;
      const _cellWidth = state.cellWidth;
      const toltalNums = getters.durationTimeArr.length;
      const baseCellScale = _ganttBoxWidth / (_cellWidth * toltalNums);
      return baseCellScale;
    } else {
      return state.cellScale;
    }
  },
  /*
    ===依赖 durationTimeArr minFillCellScale  ===
    实际应用比例
    放大填充模式：对比取填满一屏宽度比例与后台比例中较大值
    数量填充模式：取后台比例值
    return: Number
  */
  realCellScale(state, getters) {
    const fillType = state.viewSchem.timelineFillType;
    let realCellScale = state.cellScale;
    if (fillType === 2) {
      realCellScale = Math.max(getters.minFillCellScale, state.cellScale);
      console.log("显示比例[缩放]:", realCellScale);
    } else if (fillType === 1) {
      console.log("显示比例[数量]:", realCellScale);
    } else {
      console.log("显示比例[原始]:", realCellScale);
    }
    return realCellScale;
  },

  // 实际最小单元格宽度  ===依赖 realCellScale ===
  cellWidth(state, getters) {
    const _result = state.cellWidth * getters.realCellScale;
    return _result;
  },
  // 时间轴总宽  ===依赖 noGantt durationTimeArr cellWidth ===
  timesTotalWidth(state, getters) {
    const result = getters.durationTimeArr;
    const _baseWidth = getters.cellWidth;
    const _arrLen = result.length;
    if (!(result instanceof Array) || _arrLen <= 0 || getters.noGantt) {
      return 0;
    } else {
      return (_baseWidth * _arrLen);
    }
  },
  // 打印拼凑内容总宽 ===依赖 WBSLeft timesTotalWidth ===
  printTotalWidth(state, getters) {
    return getters.WBSLeft + getters.timesTotalWidth;
  },

  // <==========↓↓↓↓↓↓==========> 无引用依赖状态 <==========↓↓↓↓↓↓==========>

  // 阈值·是否需改变打印视图显示拼凑全图(列数量填充/有滚动隐藏内容/打印)
  printViewChangeFlag(state, getters) {
    return (
      state.viewSchem.isPrintModeShow || state.printStatus
    );
  },
  /* 树结构样式·显示字体大小·显示字体加粗 */
  treeFontSize(state) {
    const _treeFontSize = state.viewSchem.treeFontSize;
    return (_treeFontSize >= 6) ? _treeFontSize : "";
  },
  treeFontWeight(state) {
    const _treeFontWeight = state.viewSchem.treeFontWeight;
    return _treeFontWeight;
  },
  /* 右侧甘特图区背景网格线·竖线、横线 */
  gridYBgConfig(state) {
    const result = {
      isShow: false,
      step: 0,
      type: "solid",
    };
    try {
      const _isShow = state.viewSchem.otherSet.hline.otherShowhline;
      const type = state.viewSchem.otherSet.hline.otherAssishlinetype;
      const step = parseInt(state.viewSchem.otherSet.hline.otherInternalcol);
      result["isShow"] = _isShow;
      result["step"] = step >= 0 ? step : 0;
      result["type"] = type;

    } catch (error) {
      console.warn(error);
    }
    return result;
  },
  gridXBgConfig(state) {
    const result = {
      isShow: false,
      step: 0,
      type: "solid",
    };
    try {
      const _isShow = state.viewSchem.otherSet.lline.otherShowlvlline;
      const type = state.viewSchem.otherSet.lline.otherAssislinetype;
      const step = parseInt(state.viewSchem.otherSet.lline.otherInternalrow);
      result["isShow"] = _isShow;
      result["step"] = step >= 0 ? step : 0;
      result["type"] = type;

    } catch (error) {
      console.warn(error);
    }
    return result;
  },
  // 拖拽目标类型
  dropTargetType(state, getters) {
    const _type = state.viewSchem.dropTargetType;
    if (_type == 2) {
      return 2;
    } else {
      return 1;
    }
  },
  // 打印模式·巴条标签文字大小
  barsWordStyle(state, getters) {
    const fs = state.viewSchem.barsFontSize;

    if (
      fs >= 10 &&
      state.viewSchem.isPrintModeShow
    ) {
      const fsStr = fs;
      return {
        "font-size": fsStr + "px",
        "line-height": fsStr + "px",
        "height": fsStr + 4 + "px",
      };
    } else {
      return {};
    }
  },

};
export default getter;
